<template>
  <div class="h-48">
    <div v-if="isLoading" class="text-center">
      <aha-spinner />
    </div>

    <div v-if="showWarningEmptyFolder" class="py-3">
      {{ $i18nPresenter.t("There’s no folder to move to. Please create a new folder first.") }}
    </div>

    <div v-if="showWarningNoSharedFolder" class="py-3 text-center">
      {{ $i18nPresenter.t("No Shared folders available") }}
    </div>

    <div class="h-48 overflow-auto" v-if="!onlyRootOrNone">
      <aha-radio
        class="folder-list__radio-btn"
        :key="folder.folderId"
        v-for="folder in folders"
        :value="folder.folderId"
        v-model="localDestinatedFolderId"
        :class="[{
          'disabled': folder.disabled,
          'ml-8': !isPersonalWorkingMode && folder.folderId,
          'hidden': folder.depth && folder.depth > 10
        }, `ml-${folder.depth + 5 * folder.depth}`]"
        :disabled="folder.disabled"
        v-tooltip="(folder.countPresentation && folder.countPresentation === parseInt(maxPresentationInFolder)
          && folder.depth !== 0) ? maxPresentationFolderTooltip : null"
      >
        <span class="folder-list__icon-circle">
          <aha-icon name="folder" class="folder-list__icon" />
        </span>
        <span
          class="folder-list__folder-name"
          :class="{'pr-1': folder.folderName === 'My presentations'}"
        >
          {{ folder.folderName }}
        </span>
      </aha-radio>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moveFolderMixin from '@/mixins/folder/move-folderMixin'

export default {
  name: 'GeneralTreeFolder',
  mixins: [moveFolderMixin],
  computed: {
    ...mapState('movePresentation', {
      isLoading: (state) => state.isLoading,
      tabContent: (state) => state.tabContent,
    }),
    showWarningEmptyFolder() {
      return !this.isLoading && this.onlyRootOrNone && this.tabContent === 'TabMyPresentations'
    },
    showWarningNoSharedFolder() {
      return !this.isLoading && this.onlyRootOrNone && this.tabContent === 'TabSharedWithMe'
    },
  },
}
</script>

<style lang="scss" scoped>
.folder-list__radio-btn {
  @apply pr-2 mb-2;
  .folder-list__icon-circle {
    @apply rounded-full bg-purple-10 w-max p-2;
    .folder-list__icon {
      @apply text-purple-50;
    }
  }
  .folder-list__folder-name {
    @apply pl-2 overflow-hidden overflow-ellipsis;
  }
  &.disabled {
    &.radio-component {
      @apply cursor-not-allowed;
    }
    .folder-list__icon-circle {
    @apply bg-base-10;
    .folder-list__icon {
      @apply text-base-60;
    }
  }
    .folder-list__folder-name {
      @apply text-base-80
    }
  }
}
</style>
